import { defineComponent as _defineComponent } from 'vue'
import BCXCard from '@/components/molecules/BCXCard.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import useInfoBoxState from '@/state/infoBox';
import ByteCookieIcon from '@/components/svg/logo/logo-circles-only.svg?inline';
import { computed } from 'vue';
import { sample } from 'lodash';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardInfoBox',
  setup(__props) {

const { tUserFallback: t } = useUser('self');
const { infoBoxState } = useInfoBoxState();

const text = computed(() => {
  if (!infoBoxState.text) return '';
  const textOrTexts = t(infoBoxState.text);
  return textOrTexts ? (Array.isArray(textOrTexts) ? sample(textOrTexts) : textOrTexts) as string : '';
});

const headline = computed(() => t(infoBoxState.headline));


return { __sfc: true,t, infoBoxState, text, headline, BCXCard, BCXMarkdown, ByteCookieIcon }
}

})